import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import ManagerHeader from "../manager-dashboard/ManagerHeader.js";
import api from "../../api/axios.js";
import ManagerSelectedEmployeeCard from "./ManagerSelectedEmployeeCard.js";

const ManagerFeedbackQuizList = () => {
  const navigate = useNavigate();
  const {employeeId} = useParams();

  const [employee, setEmployee] = useState(null);
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    // employee data api
    api
      .get(`/api/feedback/employee/${employeeId}`)
      .then((res) => {
        setEmployee(res.data)
      })
      .catch((err) => {
      console.log(err);
    });

    api
      .get("/api/feedback/quizzes")
      .then((res) => {
        setQuizzes(res.data);
      })
      .catch((err) => {
      console.log(err);
    });
  }, []);

  if(!employee)
    return <p>Loading...</p>

  return(
    <>
      <div className="dashboard-wrapper">
        <ManagerHeader />

        <div className="manager_feedback_quiz_box">
          {/* employee photo side */}
          <ManagerSelectedEmployeeCard
            title={`Select employee to give feedback`}
            employee={employee}
          />
          {/* quiz list side */}
          <div className="manager_feedback_quiz_side">
            <p className="manager_feedback_select_employee">Select lesson to give feedback</p>
            <div className="manager_feedback_quiz">
            <div className="manager_feedback_quiz_list">
              {quizzes.map((quiz) => {
                return(
                  <div key={quiz._id} className="manager_quiz_card">
                    <p>Pre-job Preparation</p>
                    <img
                      src="/images/quiz-image.png"
                      alt="Pre-job Preparation"
                      className="manager_quiz_image"
                    />
                    <button onClick={() => {
                      navigate(
                        "/manager/feedback/" + employeeId + "/" + quiz._id + "/form",
                        {state:
                          {employeeName: employee.employeeName,
                           quizTitle: quiz.title
                          }
                        }
                      )
                    }} >Give feedback</button>
                  </div>
                  
                )
              })}

            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}

export default ManagerFeedbackQuizList;